module.exports = __webpack_public_path__ + "static/media/Illus-Seasonal@2x.d49e0e04.png";